import React from 'react';
import { connect } from 'react-redux';
import NotificationBanner from '../NotificationBanner/NotificationBanner';
import { setNotificationCompletePensionOrContributionRequestDismissed, COMPLETE_ADD_PENSION_REQUEST_DISMISSED } from '../../redux/modules/notificationTracking';
import { getFirebaseUid } from '../../redux/selectors';

const AddPensionRequestNotification = ({
  uid,
  dispatchSetNotificationCompleteContributionRequestDismissed,
}) => {
  return (
    <NotificationBanner
      alertCategory={'Blue'}
      alertTitle={'Complete your request'}
      alertDescription={'You started a request to find and combine an old pension, complete your request today to give yourself a brighter future at retirement.'}
      ctaButtonOptions={{
        label: 'Add pensions',
        to: '/add-pensions',
        event: COMPLETE_ADD_PENSION_REQUEST_DISMISSED,
        handleClick: () => {
          dispatchSetNotificationCompleteContributionRequestDismissed(uid, 'pension');
        },
      }}
      closeButtonOptions={{
        event: COMPLETE_ADD_PENSION_REQUEST_DISMISSED,
        handleClick: () => dispatchSetNotificationCompleteContributionRequestDismissed(uid, 'pension'),
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  uid: getFirebaseUid(state),
});

const mapDispatchToProps = ({
  dispatchSetNotificationCompleteContributionRequestDismissed:
    setNotificationCompletePensionOrContributionRequestDismissed,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPensionRequestNotification);
